import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ScheduleTabs from './scheduleTabs';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogTitle, IconButton } from '@mui/material';
import styles from './home.module.scss';
import { useState, useEffect } from 'react';
import Carousel from './Carousel/Carousel';
import AllEvents from '../devotee/dashboard/events/allEvents';
import SliderServices from '../Services/SliderServices';
import Others from '../others/Others';
import { apiRequest, catchErrorMessageHandler } from '../../infrastructure/backendService';
import { CMS_BASE_URL } from '../../config/apiUrl';
import CommonDonationPopup from './CommonDonationPopup';
import ToastError from '../common/toast/toastError';
import toast from 'react-hot-toast';
import { isNil } from 'lodash';
import ErrorPopup from '../common/ErrorPopup';
import constants from "../../config/constants.json";

export default function Home(): React.ReactElement {
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const [scroolMessageData, setscroolMessageData] = useState([]);
   const [showMsg, setShowMsg] = useState<boolean>(false);
   const handleClose = (): void => {
      setIsOpen(false);
   };

   useEffect(() => {
      apiRequest({
         basePath: `${CMS_BASE_URL}`,
         method: 'GET',
         endpoint: '/wp-json/wp/v2/scroll-message',
         includeToken: false
      })
         .then((res) => {
            const acfList = res.data.map((item: any) => item.acf);
            if(acfList[0].enable_scroll[0] === "enable") {
               setscroolMessageData(acfList);
               setShowMsg(true);
            } else {
               setscroolMessageData([]);
               setShowMsg(false)
            }
            // setscroolMessageData(acfList);
            console.log(acfList[0].enable_scroll[0], "Acf List");
         })
         .catch((err) => {
            console.log(err);
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
               duration: constants.TOAST_POPUP_DURATION,
             });
         });
   }, []);
   
   return (
      <>
         <Box>
            <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
               {showMsg ? <Grid item xs={12} md={12}>
                  <div className={styles.scrollingtext}>
                     {scroolMessageData.map((eachItem: any, index) => (
                        eachItem.scroll_message && (
                           <div key={index} className={styles.header}><span className={styles.scrollheader} dangerouslySetInnerHTML={{ __html: eachItem.scroll_message }} /></div>
                        )
                     ))}
                  </div>
               </Grid> : ""}
               <Grid item xs={12} md={12}>
                  <Carousel />
               </Grid>
               <Grid item xs={12} md={12}>
                  <SliderServices />
               </Grid>
               <Grid item xs={12} md={12}>
               <Grid container spacing={2}>
                  <Grid item xs={12} sm={7}>
                     <AllEvents setIsOpen={setIsOpen} />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                     <ScheduleTabs />
                  </Grid>
               </Grid>
               </Grid>
               <Grid item xs={12} md={12}>
                  <Others />
               </Grid>
            </Grid>
         </Box>
         <div className={styles.scrollbar}>
            <Dialog
               open={isOpen}
               aria-labelledby="alert-dialog-title"
               aria-describedby="alert-dialog-description"
               maxWidth="xl"
               PaperProps={{
                  style: {
                     overflowY: 'unset',
                     borderTopLeftRadius: "16px",
                     borderTopRightRadius: "16px",
                  },
               }}
            >
               <div
                  style={{
                     backgroundColor: '#882E14',
                     height: '76px',
                     borderTopLeftRadius: "16px",
                     borderTopRightRadius: "16px",

                  }}
               >
                  <DialogTitle sx={{ fontWeight: 700, fontSize: 36, color: 'white', }}>
                     {'Donation'}
                  </DialogTitle>
                  <IconButton
                     aria-label="close"
                     onClick={handleClose}
                     sx={{
                        position: 'absolute',
                        right: 24,
                        top: 16,
                        color: (theme: any) => theme.palette.grey[500],
                     }}
                  >
                     <CloseIcon sx={{ color: 'white' }} />
                  </IconButton>
               </div>
               <CommonDonationPopup isOpen={isOpen} setIsOpen={setIsOpen} />
            </Dialog>
         </div>
      </>
   );
}